export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_25-5b74bdd0e4e1ba250893af3550f1c6be.jpg";